var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.923 11.692c-.68 0-1.23.551-1.23 1.231v22.154c0 .68.55 1.23 1.23 1.23h22.154c.68 0 1.23-.55 1.23-1.23V12.923c0-.68-.55-1.23-1.23-1.23H12.923zm0-3.692h22.154A4.923 4.923 0 0140 12.923v22.154A4.923 4.923 0 0135.077 40H12.923A4.923 4.923 0 018 35.077V12.923A4.923 4.923 0 0112.923 8z",
    id: "checkbox-empty_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "checkbox-empty_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#checkbox-empty_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#checkbox-empty_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#checkbox-empty_svg__b)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTEyLjkyMyAxMS42OTJjLS42OCAwLTEuMjMuNTUxLTEuMjMgMS4yMzF2MjIuMTU0YzAgLjY4LjU1IDEuMjMgMS4yMyAxLjIzaDIyLjE1NGMuNjggMCAxLjIzLS41NSAxLjIzLTEuMjNWMTIuOTIzYzAtLjY4LS41NS0xLjIzLTEuMjMtMS4yM0gxMi45MjN6bTAtMy42OTJoMjIuMTU0QTQuOTIzIDQuOTIzIDAgMCAxIDQwIDEyLjkyM3YyMi4xNTRBNC45MjMgNC45MjMgMCAwIDEgMzUuMDc3IDQwSDEyLjkyM0E0LjkyMyA0LjkyMyAwIDAgMSA4IDM1LjA3N1YxMi45MjNBNC45MjMgNC45MjMgMCAwIDEgMTIuOTIzIDh6IiBpZD0iYSIvPjwvZGVmcz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjx1c2UgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHhsaW5rOmhyZWY9IiNhIi8+PGcgbWFzaz0idXJsKCNiKSIgZmlsbD0iY3VycmVudENvbG9yIj48cGF0aCBkPSJNMCAwaDQ4djQ4SDB6Ii8+PC9nPjwvZz48L3N2Zz4=";
export { SvgCheckboxEmpty as ReactComponent };